import { EventEmitter } from 'events';
import dispatcher, { DispatcheEvent } from '../dispatcher';

class UserStore extends EventEmitter {

  private user?: any;

  constructor() {
    super();
  }

  getUser() {
    return this.user;
  }

  setUser(user: any) {
    this.refreshUser(user);
  }

  clear() {
    this.refreshUser(null);
  }

  handleActions(action: DispatcheEvent) {
    switch (action.type) {
      case 'REFRESH_USER': {
        this.refreshUser(action.value);
        break;
      }

      case 'REMOVE_USER': {
        this.refreshUser(null);
        break;
      }

      default: {
        break;
      }
    }
  }

  private refreshUser(user: any) {
    this.user = user;
    this.emit('change');
  }
}

const userStore = new UserStore();
dispatcher.register(userStore.handleActions.bind(userStore) as any);
export default userStore;
